import React from "react"

import CarouselWrapper from "./carousel"

const FlexCards = props => {
  const { title, cardData } = props
  // console.log("props flex card",props)
  const carousels = []
  let numberOfCarousels = 0
  let lazyLoadImage = false
  for (var i = 0; i < cardData.length; i = i + 4) {
    numberOfCarousels = numberOfCarousels + 1

    if (i === 0) {
      lazyLoadImage = false
    } else {
      lazyLoadImage = true
    }

    carousels.push(
      <CarouselWrapper
        numberOfCarousels={numberOfCarousels}
        dataTitle={title}
        data={cardData.slice(i, i + 4)}
        lazyLoadImage={lazyLoadImage}
        enableProgressiveImageLoading={true}
      />
    )
  }

  return <div>{carousels}</div>
}

export default FlexCards
